export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Block2-46e531ef95b08ac0d51e630a565f46da.png";